import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SplashPage from "./Components/SplashPageReact";
import About from "./Components/About";
import SiteHomepage from "./Components/SiteHomePage";
import Home from "./Components/portal/Home";
import ScoutSites from "./Components/portal/ScoutSites";
import AdminPage from "./Components/portal/AdminPage";
import ProgressTracking from "./Components/portal//ProgressTracking";

const AppLayout = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/siteowner" element={<SiteHomepage />} />
        <Route path="/login" element={<Home />} />
        <Route path="/sites" element={<ScoutSites />} />
        <Route path="/profile" element={<AdminPage />} />
        <Route path="/tracking" element={<ProgressTracking />} />
      </Routes>
    </Router>
  );
};

// create root using createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));
// passing react element inside root
root.render(<AppLayout />);
